import React, { useState } from "react";
import axios from "axios";

const PaymentGateway = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const createOrder = async (orderDetails) => {
    const url = "https://sandbox-merchant.revolut.com/api/orders"; // Sandbox URL
    const apiKey = "sk_O_zmHLxrqaI3E3aLMvwnoE8qB-z_XTgb3y5gRYhFNMGdFg5SRHI0pX3_njwwLFYZ"; // Replace with your Sandbox API Key
  
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiKey}`,
      },
    };
  
    try {
      const response = await axios.post(url, orderDetails, config);
      return response.data;
    } catch (error) {
      console.error("Error creating order:", error.response || error.message);
      throw error;
    }
  };

  const processPayment = async (orderId, paymentDetails) => {
    const url = `https://sandbox-merchant.revolut.com/api/orders/${orderId}/payments`;
    const apiKey = "sk_O_zmHLxrqaI3E3aLMvwnoE8qB-z_XTgb3y5gRYhFNMGdFg5SRHI0pX3_njwwLFYZ"; // Replace with your Sandbox API Key
  
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiKey}`,
      },
    };
  
    try {
      const response = await axios.post(url, paymentDetails, config);
      return response.data;
    } catch (error) {
      console.error("Error processing payment:", error.response || error.message);
      throw error;
    }
  };

  const handlePayment = async () => {
    setLoading(true);
    setMessage("");

    // Step 1: Create an order
    const orderDetails = {
      amount: 1000, // Amount in the smallest currency unit (e.g., 1000 = $10.00)
      currency: "USD",
      capture_mode: "AUTOMATIC", // Or "MANUAL"
      merchant_order_ext_ref: 4332424243, // Replace with your unique order reference
    };

    try {
      const order = await createOrder(orderDetails);

      // Step 2: Process payment
      const paymentDetails = {
        card_number: "4111111111111111", 
        card_expiry_month: "12",
        card_expiry_year: "2024",
        card_security_code: "123",
      };

      const payment = await processPayment(order.id, paymentDetails);

      setMessage("Payment Successful: " + JSON.stringify(payment));
    } catch (error) {
      setMessage("Payment Failed: " + (error.response?.data || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1>Revolut Payment Gateway</h1>
      <button onClick={handlePayment} disabled={loading}>
        {loading ? "Processing..." : "Pay Now"}
      </button>
      {message && <p>{message}</p>}
    </div>
  );
};

export default PaymentGateway;
